import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { loginApi } from "@/utils/apis/auth-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useChangePasswordSuccess = () => {
    const { sendEvent } = useCreateEvent()
    const { login } = useAuthStore();
    const navigate = useNavigate()
    const location = useLocation();

    const email = location?.state?.email ?? "";
    const password = location?.state?.password ?? "";

    const callLogin = useCallback(async () => {
        try {
            const result = await loginApi(email, password)
            if (result.idToken && result.accessToken && result.userId && result.refreshToken && result.expiryTime) {
                await sendEvent({
                    event: EventType.LOGIN_SUCCESS,
                    user_id: result.userId,
                });
                login(result.idToken, result.userId, result.accessToken, result.refreshToken, result.expiryTime);
                navigate("/fetch-user-data");
            } else {
                throw new Error("Missing token or user information in the response.");
            }
        } catch (error) {
            if (error instanceof Error) {
                await sendEvent({
                    event: EventType.LOGIN_FAILED,
                    sub_category: "exception",
                    event_metadata: { email, message: error.message }
                });
            }
            navigate("/login")
        }
    }, [email, password, navigate, login, sendEvent]);

    useEffect(() => {
        if (!email || !password) {
            navigate("/login");
            return;
        }
        const timer = setTimeout(() => {
            callLogin();
        }, 1500);
    
        return () => clearTimeout(timer);
    }, [callLogin, email, password, navigate]);

    return { email, password };
}